import { Component, Inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import * as moment from 'moment';
import {Moment} from 'moment';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import {constants} from 'src/app/shared/common/contants';
import {validationmethod} from 'src/app/shared/common/validationmethod';
import { IncrDataLoadScheduleService } from 'src/app/shared/services/incr-data-load-schedule.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';

export interface checkinListDialogData {

  edata: any;
  page: any;
  columns: any;
  scheduleFor:any;
}
export interface purgeDetailsPopupEditData {
  editData: any;
  buttonName: string;
}

@Component({
    selector: 'app-purge-details-popup',
    templateUrl: './purge-details-popup.component.html',
    styleUrls: ['./purge-details-popup.component.scss'],
    standalone: false
})
export class PurgeDetailsPopupComponent implements OnInit {
 
  tenantId:number;
  retentionPeriod:number;
  records:any[] =[];
  selectedGroupName :string = '';
  groupNames:string[] = [];
  groupName:string='Select';
  FormValid: FormGroup;
 
  _inputCtrl: FormControl = new FormControl();
  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  gridColumnAPIDispatch;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  btnName: any;
  validation_messages: any;
  backgroundColorButton = '';
  batchPlantCompanyData: any;

  options: any = [];
 
  gridReadParam
   
  gridOptions
  
  dateType: any = ""
  
  scheduleName:string = '';

  getdata: any;
 
  scheduleid: any;
  startYear: any;
  endYear: any;
  timeScheduleDescription: string;
  scheduledOn: any = [];
  materialData: any;
  date: any;
  header

  headerName
  scheduleFor
  selectedOption: string;
 

  @ViewChildren(MatSelect) selects: QueryList<MatSelect>;
  updatedData: any;
  arrayData: any;


  constructor(public dialogref: MatDialogRef<PurgeDetailsPopupComponent>, private localStorageSettings: LocalStorageSettingsService,
    @Inject(MAT_DIALOG_DATA) public data: purgeDetailsPopupEditData, private snackbar: MatSnackBar, private errorMsg: ErrorMessages,
    private constants: constants,
    private validation: validationmethod,
    private fb: FormBuilder,
    private commanService: CommonService,
    private spinner: NgxUiLoaderService,
    private responsive: BreakpointObserver) {
this.validation_messages = this.errorMsg.concreteUpdateReportMessages;
this.components = {
buttonRenderer: Actionbutton,
};
}


ngAfterViewInit() {
  this.selects.forEach(select => {
   
  });
}
ngOnInit() {

this.retrieveGroupNames();
this.responsive.observe("(max)")

this.formvalidations();

this.rowData = [];

this.updatedData = this.data.editData;

this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

sortable: true,

resizable: true,

filter: true

};
this.columnDefs = []
this.rowSelection = 'single'

this.columnDefs = [

{
  headerName: 'TenantId',
  headerTooltip: 'TenantId',
  tooltipValueGetter: (params) =>
    'TenantId : ' + params.value,
  field: 'tenantid',
  filter: 'agTextColumnFilter',
  width: 80,
  },

{
headerName: 'Table Name',
headerTooltip: 'Table Name',
tooltipValueGetter: (params) =>
  'Table Name: ' + params.value,
field: 'tablename',
filter: 'agTextColumnFilter',
width: 180,
},
{
headerName: 'Table Deletion Order',
headerTooltip: 'Table Deletion Order',
tooltipValueGetter: (params) =>
  'Table Deletion Order :' + params.value,
field: 'tabledeletionorder',
filter: 'agTextColumnFilter',
width: 80,
},
{
headerName: 'Key Column',
headerTooltip: 'Key Column',
tooltipValueGetter: (params) =>
 'Key Column :' + params.value,
field: 'keycolumn',
filter: 'agTextColumnFilter',
width: 180,
},
{
headerName: 'Date Column',
headerTooltip: 'Date Column',
tooltipValueGetter: (params) =>
  'Date Column : ' + params.value,
field: 'datecolumn',
filter: 'agTextColumnFilter',
width: 180,
},
{
headerName: 'Configured dnsId Name',
headerTooltip: 'Scheduled On',
tooltipValueGetter: (params) =>
  'Scheduled On : ' + params.value,
field: 'configureddnsidname',
filter: 'agTextColumnFilter',
width: 180,
},
{
headerName: 'Group Name',
headerTooltip: 'Group Name',
tooltipValueGetter: (params) =>
  'Group Name : ' + params.value,
field: 'groupname',
filter: 'agTextColumnFilter',
width: 180,
},
{
  headerName: 'Column Filter Name',
  headerTooltip: 'Column Filter Name',
  tooltipValueGetter: (params) =>
    'Column Filter Name : ' + params.value,
  field: 'columnfilter',
  filter: 'agTextColumnFilter',
  width: 180,
 },
 {
  headerName: 'Filter Value',
  headerTooltip: 'Filter Value',
  tooltipValueGetter: (params) =>
    'Filter Value : ' + params.value,
  field: 'filtervalue',
  filter: 'agTextColumnFilter',
  width: 180,
  },

{
headerName: 'Status',
headerTooltip: 'Status',
tooltipValueGetter: (params) =>
  'Status : ' + params.value,
field: 'status',
filter: 'agTextColumnFilter',
width: 180,
},
{
headerName: 'Created By',
headerTooltip: 'Created By',
tooltipValueGetter: (params) =>
  'Created By : ' + params.value,
field: 'createdBy',
filter: 'agTextColumnFilter',
width: 180,
},

{
headerName: 'Created Date',
headerTooltip: 'Created Date',
tooltipValueGetter: (params) =>
  'Created Date : ' + params.value,
field: 'createdDate',
filter: 'agTextColumnFilter',
width: 180,
},

{
headerName: 'Last Modified By',
headerTooltip: 'Last Modified By',
tooltipValueGetter: (params) =>
  'Last Modified By : ' + params.value,
field: 'lastModifiedBy',
filter: 'agTextColumnFilter',
width: 180,
},
{
headerName: 'Last Modified Date',
headerTooltip: 'Last Modified Date',
tooltipValueGetter: (params) =>
  'Last Modified Date: ' + params.value,
field: 'lastModifiedDate',
filter: 'agTextColumnFilter',
width: 180,
},


];


this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');

this.updatedData = this.data.editData;
this.btnName = this.data.buttonName;
if(this.btnName === 'Update'){
   console.log(this.updatedData);
console.log(this.updatedData.purgeid)
console.log(this.updatedData?.retentionperiod)
if(this.updatedData.purgeid != undefined){
  this.FormValid.patchValue({
    groupName: this.updatedData?.groupname,
    positiveNumber:this.updatedData?.retention
  });
  this.FormValid.get('groupName')?.disable();
  this.groupName=this.updatedData.groupname,
  this.retentionPeriod = this.updatedData.retention
  console.log(this.updatedData.tabledetails)
  this.arrayData = this.updatedData.tabledetails;
  this.rowData = JSON.parse(this.arrayData)
  console.log(this.rowData)
  this.gridAPI.setGridOption('rowData', this.rowData);

}
}

this.btnName = 'Save';

}

formvalidations() {
this.FormValid = new FormGroup({
groupName:new FormControl('',[Validators.required,]),
positiveNumber: new FormControl('', [
  Validators.required,
  Validators.pattern('^[1-9][0-9]*$') // Only positive integers
]),

});

}

onGridReady(params) {
this.gridReadParam = params
this.gridAPI = params.api;
this.gridColumnAPI = params.columnApi;

}

onPaginationChangedReturn() {
if (this.gridAPI) {
this.lastPage = this.gridAPI.paginationIsLastPageFound();
this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
this.nextPagePlusOne =
this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
this.totalPages = this.gridAPI.paginationGetTotalPages();
}
}

// below function is for changing the no of rows per page
onPageSizeChanged() {
console.log('Return page size');
let value = this.pageSize;
this.gridAPI.setGridOption('paginationPageSize', Number(value));
}

// below function is for going to next page
onBtNext() {
console.log('next');
this.gridAPI.paginationGoToNextPage();
}

// below function for going to previous page
onBtPrevious() {
console.log('previous');
this.gridAPI.paginationGoToPreviousPage();
}

// below function for going to first page
onBtFirst() {
this.gridAPI.paginationGoToFirstPage();
}

// below function for going to last page
onBtLast() {
this.gridAPI.paginationGoToLastPage();
}

//excel export function
onBtExport() {
this.gridAPI.exportDataAsCsv();
}

onSearchChange(searchValue: number) {
this.gridAPI.paginationGoToPage(searchValue - 1);
}

close() {
this.dialogref.close();
}

 /*
  Author- Venkata Shyam
  15-12-2024
  Implemented to save the records 
*/

async updateData() {
  
  const tenantid = localStorage.getItem('dnsName');
  if (tenantid) {
    this.tenantId = parseInt(tenantid, 10); // Convert to integer with base 10
    if (isNaN(this.tenantId)) {
      console.error('Invalid tenantId in localStorage:', tenantid);
      this.spinner.stop();
      return;
    }
    console.log(this.tenantId); // Outputs the number
    this.spinner.start();
  }
 
  if (!this.FormValid.valid) {
    const requiredField : any = Object.keys(this.FormValid.controls).find(
      (controlName) => this.FormValid.controls[controlName].hasError('required')
    );
    this.spinner.stop();
    console.log(requiredField);
    const requiredFieldName = this.FormValid.get(requiredField)
    console.log(requiredFieldName);
    console.log(`The ${requiredFieldName} field is required`);
    this.snackbar.open(`The ${requiredFieldName} field is required`, 'OK', {duration: 5000,});

    this.validation.validateAllFormFields(this.FormValid);
    this.validation.getvalidationmessage();
    return;
  }else{
    console.log("log data");
  
    const data ={
     groupName: this.groupName,
     retentionPeriod: this.FormValid.get('positiveNumber').value,
     tableData: this.records,
     tenantId:this.tenantId,
     status: 'Yes'
   };
    this.commanService.savePurgeData(data).subscribe(response => {
      if (response.error == true) {
        console.log('inside error');
        console.log(response);
        this.spinner.stop();
        this.dialogref.close();
        this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});

      } else {

        this.spinner.stop();
        this.dialogref.close();
        this.snackbar.open(response.statusMessage, 'OK', {duration: 50000});
      }
    });
  }

}

refresh() {
this.onGridReady(this.gridAPI)

}

 /*
  Author- Venkata Shyam
  15-12-2024
  Implemented to retrieve all groupnames 
*/
retrieveGroupNames(){
  
  this.commanService.retrieverecordsForPurge().subscribe(
    {
      next:(respnse)=>{
        console.log(respnse)
        this.groupNames = respnse;
      },
      error:(response) =>{
        this.snackbar.open('Failed to load group names', 'Close', { duration: 3000 });
        console.error('Error fetching group names:', response);
      }
    }
  )

}

 /*
  Author- Venkata Shyam
  15-12-2024
  Implemented to select the particular groupname from dropdown
*/
onGroupSelect(event: any){
  
  this.groupName = event.value;
  console.log(event.value,this.groupName);
  this.customArray= [];
  this.commanService.selectedGroupName(this.groupName).subscribe(
    (response) => {
      console.log('Response from backend:', response);
      this.records = response;
     this. loadRecords();
    },
    (error) => {
      console.error('Error occurred while sending data:', error);
    }
  );

}

 /*
  Author- Venkata Shyam
  15-12-2024
  Implemented to load the data of configured purge data based on selected groupname
*/
customArray = []
loadRecords(){
  
  console.log(this.records);
  if(this.records.length > 0){{
    for(const item of this.records){
      this.customArray.push({
        tablename:item.tablename,
        tabledeletionorder:item.tabledeletionorder,
        groupname:item.groupname,
        tenantid:item.tenantid,
        keycolumn:item.keycolumn,
        datecolumn:item.datecolumn,
        configureddnsidname:item.configureddnsidname,
        columnfilter:item.columnfilter,
        filtervalue:item.filtervalue,
        status:item.status,
        createdBy:item.createdBy,
        createdDate:item.createdDate,
        lastModifiedBy:item.lastModifiedBy,
        lastModifiedDate:item.lastModifiedDate
      })
    }
    console.log(this.customArray)
    this.gridAPI.setGridOption('rowData', this.customArray);

  }
}

}

}
